<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("_EDIT_USER.INFO") }}</h4>
    </div>
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>

    <div class="grid-body p-3 border-top-unset" v-if="!isLoading">
      <v-tabs v-model="currentTabIndex" background-color="transparent" class="pl-0">
        <v-tab v-for="tabItem in tabs" :key="tabItem.index" :disabled="tabItem.disabled">{{ tabItem.label }}</v-tab>
      </v-tabs>
      <div v-if="currentTabIndex === 0" class="mt-3">
        <div class="card-item-content pt-0">
          <v-form ref="formuser" lazy-validation>
            <v-row>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.USERNAME") + $t("REQUIRED") }}</label>
                <v-text-field dense outlined :disabled="isEdit" maxlength="50" :rules="ruleName" v-model="data.userName">
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.FULLNAME") + $t("REQUIRED") }}</label>
                <v-text-field dense outlined maxlength="255" :rules="[rules.required]" v-model="data.fullName">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.GENDER") }}</label>
                <v-radio-group v-model="data.gender" row class="input-gender">
                  <v-radio color="#173d8f" :label="$t('_EDIT_USER.GENDER_MALE')" :value="1"></v-radio>
                  <v-radio color="#173d8f" :label="$t('_EDIT_USER.GENDER_FEMALE')" :value="0"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.EMAIL") + $t("REQUIRED") }}</label>
                <v-text-field :disabled="isEdit" dense outlined maxlength="255" :rules="[rules.required, rules.email]"
                  v-model="data.email">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.PHONE_NUMBER") + $t("REQUIRED") }}</label>
                <div>
                  <vue-tel-input class="input-tel" :class="phone.valid ? '' : 'border-danger'" v-model="phone.number"
                    @input="onInput" :valid-characters-only="true" :preferredCountries="['vn']" :inputOptions="{
                      placeholder: $t('CONTACT_PHONE')
                    }" :dropdownOptions="{
  showFlags: true,
  showSearchBox: true,
  showDialCodeInList: true
}"></vue-tel-input>
                </div>
              </v-col>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.ADDRESS") }}</label>
                <v-text-field dense outlined maxlength="255" v-model="data.address">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.POSITION") }}</label>
                <v-text-field dense outlined maxlength="50" v-model="data.position">
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.GROUP") }} *</label>
                <v-select outlined dense :item-text="text" :item-value="value" :items="listGroup"
                  v-model="data.userGroupId" :rules="[rules.required]"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.CHAIN") }}</label>
                <v-autocomplete item-text="text" item-value="value" :items="listChains" v-model="data.chains" outlined
                  dense multiple chips @blur="changeChain(data.chains, true)">
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 || index === 1 || index === 2">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">(+{{ data.chains.length - 3 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" class="pt-0">
                <label>{{ $t("_EDIT_USER.HOTEL") }} * &nbsp;
                  (<a class="text-primary text-decoration-underline" @click="checkAll()">{{ $t('SELECT_ALL') }}</a> | <a
                    class="text-primary text-decoration-underline"
                    @click="removeAll()">{{ $t('UN_SELECT_ALL') }}</a>)</label>
                <v-autocomplete item-text="text" item-value="value" :items="sortedListHotels" v-model="data.hotels" outlined
                  chips dense multiple deletable-chips :rules="[rules.select]">
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 || index === 1 || index === 2">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">(+{{ data.hotels.length - 3 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0">
                <v-checkbox v-model="data.owner" color="#173d8f" class="main-checkbox-no-text mt-0 pt-0"
                  :label="$t('_EDIT_USER.HOTEL_OWNER')"></v-checkbox>
              </v-col>
              <v-col cols="6" class="pt-0">
                <v-checkbox :disabled="isCurrentUser" v-model="data.active" color="#173d8f"
                  class="main-checkbox-no-text mt-0 pt-0" :label="$t('_EDIT_USER.STATUS')"></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col class="text-right">
              <v-btn depressed @click="back" class="mr-3">{{ $t('BACK') }}</v-btn>
              <v-btn color="primary" @click="validateUser" :disabled="isLoading"
                class="pl-10 pr-10">{{ $t('SAVE') }}</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-if="currentTabIndex === 1" class="mt-3">
        <table class="role-container">
          <thead>
            <tr>
              <th class="column-1 text-center">{{ $t('_EDIT_USER.NO') }}</th>
              <th class="column-2">{{ $t('_EDIT_USER.FUNCTION_CODE') }}</th>
              <th>{{ $t('_EDIT_USER.FUNCTION_NAME') }}</th>
              <th class="column-4 text-center">{{ $t('_EDIT_USER.ACTION') }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- Level 1 -->
            <template v-for="(role, index) in roles">
              <tr>
                <td class="level-1 text-center">{{ index + 1 }}</td>
                <td class="level-1">
                  <p class="mb-0 cursor" v-if="role.child && role.child.length > 0"
                    @click="role.showed = !role.showed; _forceUpdate()">
                    <v-icon class="cell-icon">{{ role.showed ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
                    <strong>{{ role.fnCode }}</strong>
                  </p>
                  <p class="mb-0" v-else>
                    <strong>{{ role.fnCode }}</strong>
                  </p>
                </td>
                <td class="level-1">{{ $t('_ROLES.' + role.fnName) }}</td>
                <td class="level-1 text-center">
                  <v-checkbox :disabled="role.disabled" v-model="role.checked" @change="toggleAll(role)" color="#173d8f"
                    class="main-checkbox-no-text justify-center mt-0 pt-0" />
                </td>
              </tr>
              <template v-if="role.showed">
                <!-- Level 2 -->
                <template v-for="(roleChild) in role.child">
                  <tr>
                    <td class="level-2 text-center"></td>
                    <td class="level-2 child">
                      <p class="mb-0 cursor" v-if="roleChild.child && roleChild.child.length > 0"
                        @click="roleChild.showed = !roleChild.showed; _forceUpdate()">
                        <v-icon class="cell-icon">{{ roleChild.showed ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
                        <strong>{{ roleChild.fnCode }}</strong>
                      </p>
                      <p class="mb-0" v-else>
                        <strong>{{ roleChild.fnCode }}</strong>
                      </p>
                    </td>
                    <td class="level-2 child">{{ $t('_ROLES.' + roleChild.fnName) }}</td>
                    <td class="level-2 text-center">
                      <v-checkbox :disabled="roleChild.disabled" v-model="roleChild.checked"
                        @change="toggleAll(roleChild, [role])" color="#173d8f"
                        class="main-checkbox-no-text justify-center mt-0 pt-0" />
                    </td>
                  </tr>
                  <template v-if="roleChild.showed">
                    <!-- Level 3 -->
                    <template v-for="(roleGrandChild) in roleChild.child">
                      <tr>
                        <td class="level-3 text-center"></td>
                        <td class="level-3 child">
                          <p class="mb-0 cursor" v-if="roleGrandChild.child && roleGrandChild.child.length > 0"
                            @click="roleGrandChild.showed = !roleGrandChild.showed; _forceUpdate()">
                            <v-icon class="cell-icon">{{ roleGrandChild.showed ? 'arrow_drop_up' :
                              'arrow_drop_down' }}</v-icon>
                            <strong>{{ roleGrandChild.fnCode }}</strong>
                          </p>
                          <p class="mb-0" v-else>
                            <strong>{{ roleGrandChild.fnCode }}</strong>
                          </p>
                        </td>
                        <td class="level-3 child">{{ $t('_ROLES.' + roleGrandChild.fnName) }}</td>
                        <td class="level-3 text-center">
                          <v-checkbox :disabled="roleGrandChild.disabled" v-model="roleGrandChild.checked"
                            @change="toggleAll(roleGrandChild, [roleChild, role])" color="#173d8f"
                            class="main-checkbox-no-text justify-center mt-0 pt-0" />
                        </td>
                      </tr>
                      <template v-if="roleGrandChild.showed">
                        <!-- Level 4 -->
                        <template v-for="(greatGrandChild) in roleGrandChild.child">
                          <tr>
                            <td class="level-4 text-center"></td>
                            <td class="level-4 child">
                              <p class="mb-0 cursor" v-if="greatGrandChild.child && greatGrandChild.child.length > 0"
                                @click="greatGrandChild.showed = !greatGrandChild.showed; _forceUpdate()">
                                <v-icon class="cell-icon">{{ greatGrandChild.showed ? 'arrow_drop_up' :
                                  'arrow_drop_down' }}</v-icon>
                                <strong>{{ greatGrandChild.fnCode }}</strong>
                              </p>
                              <p class="mb-0" v-else>
                                <strong>{{ greatGrandChild.fnCode }}</strong>
                              </p>
                            </td>
                            <td class="level-4 child">{{ $t('_ROLES.' + greatGrandChild.fnName) }}</td>
                            <td class="level-4 text-center">
                              <v-checkbox :disabled="greatGrandChild.disabled" v-model="greatGrandChild.checked"
                                @change="toggleAll(greatGrandChild, [roleGrandChild, roleChild, role])" color="#173d8f"
                                class="main-checkbox-no-text justify-center mt-0 pt-0" />
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </template>
          </tbody>
        </table>
        <div class="card-item-content">
          <v-row>
            <v-col class="text-right">
              <v-btn depressed @click="back" class="mr-3">{{ $t('BACK') }}</v-btn>
              <v-btn color="primary" @click="updateUserRole" class="pl-10 pr-10">{{ $t('SAVE') }}</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import { _alert } from "@/_helpers/function.js";
import { getMuError } from "@/_helpers/config.js";
import { service } from "@/_services/Account/ManageUser/manage-user.service.js";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import store from "@/plugins/store";
import { chainService } from "@/_services/ChainManage/chain.service.js";
const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

export default {
  components: {
    Treeselect
  },
  data() {
    return {
      sysLang: this.$i18n.locale,
      isLoading: false,
      isEdit: false,
      isCurrentUser: false,
      currentTabIndex: null,
      tabs: [
        { index: 0, disabled: false, label: this.$t("_EDIT_USER.USER") },
        { index: 1, disabled: false, label: this.$t("_EDIT_USER.ROLE") }
      ],
      data: {
        gender: 1,
        userGroupId: null,
        active: true,
        address: "",
        chains: [],
        description: null,
        email: "",
        fullName: "",
        hotels: [],
        owner: false,
        phone: "",
        position: "",
        userName: "",
      },
      currentUserRole: [],
      currentUserGroupRole: [],
      selectedUserGroup: null,
      listGroup: [],
      listAllGroups: [],
      error: getMuError(),
      roles: [],
      listChains: [],
      listHotels: [],
      rules: {
        required: value => !!value || this.$t("_REGISTER.REQUIRED_FIELD"),
        number: value => value >= 0 || this.$t("DATA_INPUT_INVALID"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t("EMAIL_INVALID")
        },
        select: value => (!!value && value.length > 0) || this.$t("_REGISTER.REQUIRED_FIELD"),
        counter: value => (!!value && value.length <= 10 && value.length >= 6) || this.$t('ERROR_PHONE_NUMBER_LENGTH'),
        phone: value => {
          const pattern = /^[1-9]{1}\d+$/
          return pattern.test(value) || this.$t('ERROR_PHONE_NUMBER_STRING')
        },
      },
      areaCode: null,
      telephone: null,
      optionCountry: [],
      phone: {
        number: "",
        valid: false
      },
    };
  },
  created() {
    this.initialize();
  },
  async mounted() {
    await service.getAllActiveUserGroup({ name: "" }).then(res => {
      // this.listAllGroups = res.data;
      this.listGroup = res.data.map(
        x => {
          return {
            value: x.id,
            text: x.groupName
          };
        }
      );
      this.listGroup = this.listGroup.filter(
        x => x.value
      );
    });

    await service.getAllChains().then(res => {
      // this.listChains = res.data;
      this.listChains = res.data.map(
        x => {
          return {
            value: x.id,
            text: x.nameVi
          };
        }
      );
      this.c = this.listChains.filter(
        x => x.value
      );

    });
    // await service.getAllHotels().then(res => {
    //   // this.listHotels = res.data;
    //   this.listHotels = res.data.map(
    //     x => {
    //       return {
    //         value: x.id,
    //         text: x.hotelCode + ' - ' + x.hotelI18n.find( y => y.lang == this.sysLang ).name
    //       };
    //     }
    //   );
    //   this.listHotels = this.listHotels.filter(
    //     x => x.value
    //   );

    // });
  },
  methods: {
    onInput(formattedNumber, { number, valid, country }) {
      this.phone.number = number;
      this.phone.valid = valid;
    },
    // Run when start
    initialize() {
      let requests = [];
      if (this.$route.params && this.$route.params.id) {
        this.isEdit = true;
        this.data.userName = this.$route.params.id;
        this.isCurrentUser =
          currentUser.user && currentUser.user.username === this.data.userName;
        requests.push(this.getUserDetail(this.data.userName));
        requests.push(this.getUserRole(this.data.userName));
      } else {
        this.changeChain(this.data.chains, false)
        this.tabs[1].disabled = true;
      }
      requests.push(this.getAllRole());
      this.isLoading = true;
      Promise.all(requests)
        .then(res => {
          if (this.isEdit) {
            // Find group name from group id, then search group by group name, populated result to select list (remote search)
            // this.getGroupDetail(this.data.userGroupId).then(() => {
            // if (this.selectedUserGroup) {
            // this.searchGroupByName(this.data.groupName);
            // }
            // });
            // Load roles checked state
            const checkedRolesId = this.currentUserRole.map(role => role.id);
            for (let role of this.roles) {
              this.checkRole(checkedRolesId, role);
            }
          }
          // this.getAreaCode();
        })
        .finally(() => (this.isLoading = false));
    },
    changeChain(data, isBlur) {
      var body = {
        lang: this.defaultI18n,
        ids: [...data]
      }
      if (isBlur) {
        this.removeAll();
      }
      chainService.getHotelListByChainList(body).then(res => {
        this.listHotels = res.data.map(
          x => {
            return {
              value: x.id,
              text: x.name
            };
          }
        );
        this.listHotels = this.listHotels.filter(
          x => x.value
        );
      });
    },
    checkAll() {
      this.data.hotels = this.listHotels.map(x => x.value);
    },
    removeAll() {
      this.data.hotels = []
    },
    // async getAreaCode() {
    //    await service.getAreaCode().then(res => {
    //     res.data.forEach(x => {
    //       if (x.phoneCode) {
    //         this.optionCountry.push( 
    //           {
    //             id: x.phoneCode,
    //             label: x.locationI18nSet.find(x => x.lang == this.sysLang).name,
    //             flag: 'https://static.oneinventory.com/flags/' + x.flagURL
    //           }
    //         );
    //       }
    // 		});
    //      if (this.$route.params && this.$route.params.id) { 
    //         this.optionCountry.forEach(e => {
    //           if (this.data.phone.includes(e.id)) {
    //             this.areaCode = e.id;
    //           }
    //         });
    //         if (this.areaCode === null) {
    //           this.areaCode = this.optionCountry[0].id;
    //           this.telephone = this.data.phone;
    //         } else {
    //           this.telephone = this.data.phone.substring(this.areaCode.length, this.data.phone.length);
    //         }
    //      } else {
    //        this.areaCode = this.optionCountry[0].id; 
    //      }
    //   });
    // },
    // load role state (recursive)
    checkRole(checkedRolesId, role) {
      if (checkedRolesId.indexOf(role.id) > -1) {
        role.checked = true;
      } else {
        role.checked = false;
      }
      if (role.child && role.child.length > 0) {
        for (let child of role.child) {
          this.checkRole(checkedRolesId, child);
        }
      }
    },
    // Check and disabled role (recursive)
    disableRole(disableRolesId, role) {
      if (disableRolesId.indexOf(role.id) > -1) {
        role.checked = true;
        role.disabled = true;
      } else {
        role.disabled = false;
      }
      if (role.child && role.child.length > 0) {
        for (let child of role.child) {
          this.disableRole(disableRolesId, child);
        }
      }
    },
    // Handle child check box
    toggleAll(item, parents) {
      if (item.child) {
        for (const child of item.child) {
          this.toggleChild(item, child);
        }
      }
      // if (parents) {
      //   for (const parent of parents) {
      //     this.toggleParent(parent);
      //   }
      // }
      this._forceUpdate();
    },
    // Handle parent checkbox
    toggleParent(parent) {
      if (parent.child) {
        parent.checked = parent.child.map(x => x.checked).reduce((a, b) => a || b, false);
      }
    },
    toggleChild(parent, child) {
      child.checked = parent.checked;
      if (child.child) {
        for (const grandChild of child.child) {
          this.toggleChild(child, grandChild);
        }
      }
    },
    // Convert role
    convertRole(roles) {
      this.roles = [];
      // Filter all root roles
      const rootRoles = roles
        .filter(role => role.parentId === null)
        .map(role =>
          Object.assign({}, role, {
            checked: false,
            showed: false
          })
        );
      this.roles = this.roles.concat(rootRoles);
      // For each root role, find all child role, add to child list, recursive until no more role found
      for (let role of this.roles) {
        role.child = this.filterChildRoles(role.id, roles);
      }
    },
    // Filter child role
    filterChildRoles(parentId, roles) {
      // End recursive condition
      if (!parentId || parentId === 0 || !roles || roles.length === 0) {
        return [];
      }
      let filterRoles = roles
        .filter(role => role.parentId === parentId)
        .map(role =>
          Object.assign({}, role, {
            checked: false,
            showed: false
          })
        );
      for (let role of filterRoles) {
        // recursive recursive recursive ...
        role.child = this.filterChildRoles(role.id, roles);
      }
      return filterRoles;
    },
    // Get checked role
    getCheckedRoles(roleList, role) {
      roleList.push(role);
      if (role.child) {
        for (let child of role.child) {
          this.getCheckedRoles(roleList, child);
        }
      }
    },
    // Go back
    back() {
      this.$router.back();
    },
    // Get all available role
    async getAllRole() {
      return await service.getAllFunction().then(res => {
        if (res.responseCode === 0) {
          this.convertRole(res.data);
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get all user group
    // async searchGroupByName(name) {
    //   return await service.getAllActiveUserGroup({ name: name }).then(res => {
    //     if (res.responseCode === 0) {
    //       this.listGroup = res.data;
    //     } else {
    //       _alert(res, this.$t(res.data), false);
    //     }
    //   });
    // },
    // Get user group detail
    async getGroupDetail(id) {
      return await service.getUserGroupDetail(id).then(res => {
        if (res.responseCode === 0) {
          this.selectedUserGroup = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get user detail
    async getUserDetail(username) {
      return await service.getUserDetail(username).then(res => {
        if (res.responseCode === 0) {
          this.data = res.data;
          this.phone.number = this.data.phone;
          this.changeChain(this.data.chains, false)
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Get user role
    async getUserRole(username) {
      return await service.getUserFunction(username).then(res => {
        if (res.responseCode === 0) {
          this.currentUserRole = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Validate user
    validateUser() {
      let isValid = this.$refs.formuser.validate();
      if (!this.phone.valid) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        return false;
      }
      if (!isValid) return false;
      if (!this.isEdit) {
        // Create
        this.createUser();
      } else {
        // Update
        this.updateUser();
      }
    },
    // Create user
    createUser() {
      let temp = {
        userName: this.data.userName,
        fullName: this.data.fullName,
        gender: this.data.gender,
        phone: this.phone.number,
        position: this.data.position,
        email: this.data.email,
        address: this.data.address,
        userGroupId: this.data.userGroupId,
        owner: this.data.owner,
        active: this.data.active,
        hotels: this.data.hotels,
        chains: this.data.chains
      };
      this.isLoading = true;
      service
        .createUser(temp)
        .then(res => {
          if (res.responseCode === 0) {
            _alert(res, this.$t("CREATE_SUCCESS"), false);
            // Set userName
            this.data.userName = res.data;
            // Switch to tab role
            this.loadTabRole();
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Update user
    updateUser() {
      let temp = {
        userName: this.data.userName,
        fullName: this.data.fullName,
        gender: this.data.gender,
        phone: this.phone.number,
        position: this.data.position,
        email: this.data.email,
        address: this.data.address,
        userGroupId: this.data.userGroupId,
        owner: this.data.owner,
        active: this.data.active,
        hotels: this.data.hotels,
        chains: this.data.chains
      };
      this.isLoading = true;
      service
        .updateUser(temp)
        .then(res => {
          if (res) {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Update user group role
    updateUserRole() {
      let flatRole = [];
      for (let role of this.roles) {
        this.getCheckedRoles(flatRole, role);
      }
      const checkedRole = flatRole
        .filter(role => role.checked)
        .map(role => role.id);
      let temp = {
        username: this.data.userName,
        funcId: checkedRole
      };
      this.isLoading = true;
      service
        .updateUserFunction(temp)
        .then(res => {
          if (res.responseCode === 0 && !this.isEdit) {
            this.back();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    },
    // load tab rolw
    loadTabRole() {
      this.tabs[1].disabled = false;
      this.currentTabIndex = this.tabs[1].index;
    },
    _forceUpdate() {
      this.$forceUpdate();
    }
  },
  computed: {
    sortedListHotels() {
      if (!Array.isArray(this.listHotels) || !Array.isArray(this.data.hotels)) return this.listHotels;
      return [...this.listHotels].sort((a, b) => {
        const aSelected = this.data.hotels.includes(a.value);
        const bSelected = this.data.hotels.includes(b.value);
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return 0;
      });
    }
  }
};
</script>